export const PLACEMENT_NO_WFB_TEMPLATE = "PLACEMENT_NO_WFB_TEMPLATE" as const;
export const PLACEMENT_NO_ORIGIN_OFFER_TEMPLATE =
  "PLACEMENT_NO_ORIGIN_OFFER_TEMPLATE" as const;
export const PLACEMENT_NO_DESTINATION_OFFER_TEMPLATE =
  "PLACEMENT_NO_DESTINATION_OFFER_TEMPLATE" as const;
export const SCORECARD_ATTRIBUTE_DRAG_CHANGED =
  "SCORECARD_ATTRIBUTE_DRAG_CHANGED" as const;
export const ORCHESTRATION_DRAG_VAL_CHANGED =
  "ORCHESTRATION_DRAG_VAL_CHANGED" as const;
export const CLEAR_LF_TABLE_ROWS = "CLEAR_LF_TABLE_ROWS" as const;
export const CLOSE_SIDE_PANEL_SECTIONS = "CLOSE_SIDE_PANEL_SECTIONS" as const;
export const GO_TO_SMARTVIEW = "GO_TO_SMARTVIEW" as const;
export const EMAIL_UPDATED = "EMAIL_UPDATED" as const;
export const SMS_UPDATED = "SMS_UPDATED" as const;
export const NOTE_UPDATED = "NOTE_UPDATED" as const;
export const CALL_UPDATED = "CALL_UPDATED" as const;
export const LOG_UPDATED = "LOG_UPDATED" as const;
export const OPEN_PIP_VIEW = "OPEN_PIP_VIEW" as const;
export const CLOSE_PIP_VIEW = "CLOSE_PIP_VIEW" as const;
export const UPDATE_PIP_DEAL = "UPDATE_PIP_DEAL" as const;
export const TOGGLE_COMMENTS = "TOGGLE_COMMENTS" as const;
export const OPEN_TEMPLATES = "OPEN_TEMPLATES" as const;
export const CMDK_DRAG_START = "CMDK_DRAG_START" as const;
